/**
 *  语言配置
 */
import { createI18n } from "vue-i18n"; //引入vue-i18n组件
const i18n = createI18n({
  globalInjection: true,
  locale: "CN", //默认显示的语言
  messages: {
    CN: require("./zh.js").default, //引入语言文件
    FR: require("./fr.js").default, //引入语言文件
    // en: require("./en.js").default,
  },
});
export default i18n;

export function useLang(lang) {
  i18n.global.locale = lang;
}
